import { usePathSelector } from "@/context/PathSelectorContext";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";

// Primary "Tell Us What You Need" trigger — reused everywhere.
export const TellUsButton = ({ className, size = "md", label = "Tell Us What You Need", testId = "tell-us-cta", path = null, onSelect }) => {
  const { openSelector } = usePathSelector();
  const sizes = {
    sm: "px-5 py-2.5 text-sm",
    md: "px-7 py-3.5 text-sm",
    lg: "px-9 py-4 text-base",
  };
  return (
    <button
      data-testid={testId}
      onClick={() => { openSelector(path); onSelect?.(); }}
      className={cn(
        "group inline-flex items-center gap-2 rounded-full bg-primary font-medium text-primary-foreground",
        "transition-[transform,background-color] duration-300 hover:bg-blue-700 active:scale-[0.97]",
        sizes[size],
        className
      )}
    >
      {label}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </button>
  );
};
